import { Paper, Typography } from '@material-ui/core'

import { FieldInfo } from '@/pages/maps/contexts/region-context'

import { useStyles } from './styles'

interface TotalAreaPaperProps {
  selectedItems: (FieldInfo & { checked: boolean })[]
}

export const TotalAreaPaper = ({ selectedItems }: TotalAreaPaperProps) => {
  const classes = useStyles()

  const checkedItems = selectedItems.filter((item) => item.checked)
  const totalArea = checkedItems.reduce((acc, item) => acc + item.area, 0)

  return (
    <Paper className={classes.totalAreaContainer}>
      <Typography variant='subtitle2'>Área a ser analisada:</Typography>
      <Typography variant='subtitle2'>{totalArea.toFixed(2)} ha</Typography>
    </Paper>
  )
}
